import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mda_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const SHOP = {
  name: "Mid Del Auto",
  address: "411 Foster Place, Midwest City, OK",
  phone: "(405) 741-1155",
  phoneTel: "+14057411155",
  hours: "Mon – Fri  10 AM – 6 PM",
};

export const SERVICES = [
  { key: "Oil Change", icon: "Droplet", desc: "Full synthetic, conventional & high-mileage oil services." },
  { key: "Brakes", icon: "Disc", desc: "Pads, rotors, calipers & complete brake system service." },
  { key: "Tires", icon: "CircleDot", desc: "Rotation, balance, mounting, alignment & new tire sales." },
  { key: "Diagnostics", icon: "ScanLine", desc: "OBD-II computer diagnostics for any check engine light." },
  { key: "Engine Repair", icon: "Cog", desc: "From minor tune-ups to full rebuilds, we handle it all." },
  { key: "Transmission", icon: "GitBranch", desc: "Fluid service, repairs and complete transmission work." },
  { key: "AC/Heating", icon: "Wind", desc: "Recharge, leak repair, compressor & heater core service." },
  { key: "Inspection", icon: "ClipboardCheck", desc: "Pre-purchase, multi-point & state safety inspections." },
];
